import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

const DEFAULT_EQUIPMENT = {
  category: 'autre',
  name: '',
  existing_quantity: 1,
  verified_quantity: 1,
  protection_type: '',
  continuity_result: '',
  isolement: '',
  result: 'conforme'
};

export default function AutreEquipementModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState(equipment || DEFAULT_EQUIPMENT);

  useEffect(() => {
    setFormData(equipment || DEFAULT_EQUIPMENT);
  }, [equipment, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name) {
      alert('Veuillez renseigner la désignation de l\'équipement.');
      return;
    }
    onSave({
      type: 'autre',
      ...formData
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">❓ Autre équipement</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <p className="equipment-info-text" style={{ marginBottom: '16px' }}>
              Saisie libre pour un équipement n'entrant dans aucune des catégories prédéfinies.
            </p>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Désignation <span className="equipment-required">*</span>
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="equipment-form-input"
                placeholder="Ex: Borne IRVE, Sèche-mains, Système d'alarme..."
                required
              />
            </div>

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({ ...formData, existing_quantity: parseInt(e.target.value) })}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité vérifiée</label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({ ...formData, verified_quantity: parseInt(e.target.value) })}
                  className="equipment-form-input"
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <input
                type="text"
                value={formData.protection_type}
                onChange={(e) => setFormData({ ...formData, protection_type: e.target.value })}
                className="equipment-form-input"
                placeholder="Ex: D, PC, IP44, etc."
              />
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Continuité PE</label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="Classe II">Classe II</option>
                <option value="Classe III">Classe III</option>
                <option value="Déconnecté">Déconnecté</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="NV">NV</option>
                <option value="SO-PI">SO-PI</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-autre"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({ ...formData, isolement: e.target.value })}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-autre">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-modal-footer">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              Annuler
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
